<template>
  <b-modal
    ref="modal"
    :title="editId ? 'Cập nhật địa chỉ người gửi' : 'Thêm địa chỉ người gửi'"
    size="md"
    no-close-on-backdrop
    hide-footer
    @hidden="onHidden"
  >
    <b-form @submit.prevent="submit">
      <b-row>
        <b-col cols="6">
          <b-form-group>
            <template #label>Họ và tên <span class="text-danger">*</span></template>
            <b-form-input
              v-model="form.name"
              placeholder="Nguyễn Văn A"
              :state="submitted && !form.name ? false : null"
            />
            <b-form-invalid-feedback>Vui lòng nhập tên người gửi</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group>
            <template #label>Số điện thoại <span class="text-danger">*</span></template>
            <b-form-input
              v-model="form.phone"
              placeholder="0901234567"
              :state="submitted && !form.phone ? false : null"
            />
            <b-form-invalid-feedback>Vui lòng nhập số điện thoại</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group label="Địa chỉ (số nhà, tên đường)">
        <b-form-input v-model="form.address" placeholder="123 Nguyễn Trãi" />
      </b-form-group>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Tỉnh / Thành phố">
            <AutoSuggest
              :model.sync="form.provinceName"
              :suggestions="filteredProvinces"
              :suggestion-name="provinceFieldName"
              placeholder="tỉnh/thành phố"
              :loading="loadingProvinces"
              show-clear
              @change="onProvinceInputChange"
              @select="onProvinceSelect"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Phường / Xã">
            <AutoSuggest
              :model.sync="form.wardName"
              :suggestions="filteredWards"
              :suggestion-name="wardFieldName"
              placeholder="phường/xã"
              :loading="loadingWards"
              :disabled="!form.provinceCode"
              show-clear
              @change="onWardInputChange"
              @select="onWardSelect"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col v-if="!lockedCarrier" cols="6">
          <b-form-group label="Nhà vận chuyển">
            <b-form-select v-model="form.carrier" :options="carrierOptions" size="sm" @change="onCarrierChange" />
          </b-form-group>
        </b-col>
        <b-col :cols="lockedCarrier ? 12 : 6" class="d-flex align-items-center pt-2">
          <b-form-checkbox v-model="form.isDefault">Đặt làm mặc định</b-form-checkbox>
        </b-col>
      </b-row>

      <div class="d-flex justify-content-end mt-3">
        <b-button variant="outline-secondary" class="mr-2" @click="$refs.modal.hide()">Hủy</b-button>
        <b-button variant="primary" type="submit" :disabled="saving">
          <b-spinner v-if="saving" small class="mr-1" />
          {{ editId ? 'Cập nhật' : 'Thêm địa chỉ' }}
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { makeToastFaile } from '@/utils/common';
import AutoSuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';

const ShippingRepo = RepositoryFactory.get('shipping');

export default {
  name: 'SenderAddressModal',
  components: { AutoSuggest },
  props: {
    storeId: { type: Number, default: null },
  },
  data() {
    return {
      editId: null,
      lockedCarrier: null,
      submitted: false,
      saving: false,
      provinces: [],
      wards: [],
      loadingProvinces: false,
      loadingWards: false,
      form: {
        name: '',
        phone: '',
        address: '',
        provinceCode: null,
        provinceName: '',
        wardCode: null,
        wardName: '',
        carrier: null,
        isDefault: false,
      },
    };
  },
  computed: {
    isVtp() {
      return this.form.carrier === 'viettelpost';
    },
    provinceFieldName() {
      return this.isVtp ? 'PROVINCE_NAME' : 'province_name';
    },
    wardFieldName() {
      return this.isVtp ? 'WARDS_NAME' : 'ward_name';
    },
    filteredProvinces() {
      const q = (this.form.provinceName || '').toLowerCase().trim();
      if (!q) return this.provinces;
      const field = this.provinceFieldName;
      return this.provinces.filter((p) => (p[field] || '').toLowerCase().includes(q));
    },
    filteredWards() {
      const q = (this.form.wardName || '').toLowerCase().trim();
      if (!q) return this.wards;
      const field = this.wardFieldName;
      return this.wards.filter((w) => (w[field] || '').toLowerCase().includes(q));
    },
    carrierOptions() {
      return [
        { value: null, text: 'Dùng chung (tất cả NVC)' },
        { value: 'nhattin', text: 'Nhất Tín Logistics' },
        { value: 'viettelpost', text: 'ViettelPost' },
      ];
    },
  },
  methods: {
    open(existing = null, carrier = null) {
      this.editId = existing?.id || null;
      this.submitted = false;
      this.lockedCarrier = carrier || null;
      this.provinces = [];
      this.wards = [];
      this.form = {
        name: existing?.name || '',
        phone: existing?.phone || '',
        address: existing?.address || '',
        provinceCode: existing?.provinceCode || null,
        provinceName: existing?.provinceName || '',
        wardCode: existing?.wardCode || null,
        wardName: existing?.wardName || '',
        carrier: carrier || existing?.carrier || null,
        isDefault: existing?.isDefault || false,
      };
      this.$refs.modal.show();
      if (this.form.carrier) {
        this.fetchProvinces();
        if (existing?.provinceCode) {
          this.fetchWards(existing.provinceCode);
        }
      }
    },

    onHidden() {
      this.editId = null;
      this.submitted = false;
    },

    onCarrierChange(newCarrier) {
      console.log('[SenderAddressModal] onCarrierChange fired, newCarrier=', newCarrier, 'form.carrier=', this.form.carrier, 'isVtp=', this.isVtp);
      this.provinces = [];
      this.wards = [];
      this.form.provinceCode = null;
      this.form.provinceName = '';
      this.form.wardCode = null;
      this.form.wardName = '';
      this.fetchProvinces();
    },

    async fetchProvinces() {
      console.log('[SenderAddressModal] fetchProvinces called, form.carrier=', this.form.carrier, 'isVtp=', this.isVtp);
      this.loadingProvinces = true;
      try {
        this.provinces = this.isVtp
          ? await ShippingRepo.getVtpProvinces()
          : await ShippingRepo.getNtProvinces();
        console.log('[SenderAddressModal] provinces loaded, count=', this.provinces.length);
      } catch (err) {
        console.error('[SenderAddressModal] fetchProvinces error', err);
        this.provinces = [];
      } finally {
        this.loadingProvinces = false;
      }
    },

    onProvinceInputChange(text) {
      if (!text) {
        this.form.provinceCode = null;
        this.form.wardCode = null;
        this.form.wardName = '';
        this.wards = [];
      }
    },

    onProvinceSelect(option) {
      if (!option?.item) return;
      const item = option.item;
      if (this.isVtp) {
        this.form.provinceCode = item.PROVINCE_ID;
        this.form.provinceName = item.PROVINCE_NAME;
      } else {
        this.form.provinceCode = item.id;
        this.form.provinceName = item.province_name;
      }
      this.form.wardCode = null;
      this.form.wardName = '';
      this.wards = [];
      this.fetchWards(this.form.provinceCode);
    },

    onWardInputChange(text) {
      if (!text) {
        this.form.wardCode = null;
      }
    },

    onWardSelect(option) {
      if (!option?.item) return;
      const item = option.item;
      if (this.isVtp) {
        this.form.wardCode = item.WARDS_ID;
        this.form.wardName = item.WARDS_NAME;
      } else {
        this.form.wardCode = item.id;
        this.form.wardName = item.ward_name;
      }
    },

    async fetchWards(provinceCode) {
      this.loadingWards = true;
      try {
        this.wards = this.isVtp
          ? await ShippingRepo.getVtpWards(provinceCode)
          : await ShippingRepo.getNtWards(provinceCode);
      } catch {
        this.wards = [];
      } finally {
        this.loadingWards = false;
      }
    },

    async submit() {
      this.submitted = true;
      if (!this.form.name || !this.form.phone) return;

      this.saving = true;
      try {
        const payload = {
          ...this.form,
          storeId: this.storeId || undefined,
        };

        let result;
        if (this.editId) {
          result = await ShippingRepo.updateSenderAddress(this.editId, payload);
        } else {
          result = await ShippingRepo.createSenderAddress(payload);
        }

        this.$emit('saved', result);
        this.$refs.modal.hide();
      } catch (err) {
        makeToastFaile(err?.response?.data?.message || 'Không thể lưu địa chỉ');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
